import {
  TaxonomyCertifications,
  TaxonomyLocation,
  TaxonomyTheme,
  TaxonomyPartner,
  TaxonomyAnnualReportTheme,
} from '../implementations';


const mappers = {
  locations: TaxonomyLocation,
  certifications: TaxonomyCertifications,
  themes: TaxonomyTheme,
  partners: TaxonomyPartner,
  annual_report_themes: TaxonomyAnnualReportTheme,
};

export default mappers;
